import { useSearchParams } from "react-router-dom";
import { DashboardKPI } from "../../components/Dashboard";
import { SystemStatusTab } from "./SystemStatusTab";
import { OwnersTab } from "./OwnersTab";
import { PatientsTab } from "./PatientsTab";
import { ConfigTab } from "./ConfigTab";
import { AppointmentsTab } from "./AppointmentsTab";
import { PushTab } from "./PushTab";
import { UsersTab } from "./UsersTab";
import { VetsTab } from "./VetsTab";
import { VisitTypesTab } from "./VisitTypesTab";
import { SpecialtiesTab } from "./SpecialtiesTab";
import { AppLayout } from "../../components/AppLayout";
import {
  LayoutDashboard,
  Users,
  Stethoscope,
  Clock,
  Building2,
  UserCircle,
  HeartPulse,
  CalendarDays,
  Settings,
  Bell,
  Activity,
} from "lucide-react";

type AdminTab =
  | "dashboard"
  | "users"
  | "vets"
  | "visit_types"
  | "specialties"
  | "owners"
  | "patients"
  | "appointments"
  | "config"
  | "push"
  | "system";

export function AdminPage() {
  const [params, setParams] = useSearchParams();

  const tabs: { id: AdminTab; label: string; icon: React.ReactNode }[] = [
    {
      id: "dashboard",
      label: "Dashboard",
      icon: <LayoutDashboard className="size-4" />,
    },
    { id: "users", label: "Utenti", icon: <Users className="size-4" /> },
    {
      id: "vets",
      label: "Veterinari",
      icon: <Stethoscope className="size-4" />,
    },
    {
      id: "visit_types",
      label: "Tipi visita",
      icon: <Clock className="size-4" />,
    },
    {
      id: "specialties",
      label: "Specialità",
      icon: <Building2 className="size-4" />,
    },
    {
      id: "owners",
      label: "Proprietari",
      icon: <UserCircle className="size-4" />,
    },
    {
      id: "patients",
      label: "Pazienti",
      icon: <HeartPulse className="size-4" />,
    },
    {
      id: "appointments",
      label: "Appuntamenti",
      icon: <CalendarDays className="size-4" />,
    },
    { id: "system", label: "Sistema", icon: <Activity className="size-4" /> },
    {
      id: "config",
      label: "Configurazione",
      icon: <Settings className="size-4" />,
    },
    { id: "push", label: "Notifiche", icon: <Bell className="size-4" /> },
  ];

  const activeTab = tabs.some((tab) => tab.id === params.get("tab"))
    ? (params.get("tab") as AdminTab)
    : "dashboard";
  const setActiveTab = (id: string) => {
    const next = new URLSearchParams(params);
    next.set("tab", id);
    setParams(next);
  };
  const panels: Record<AdminTab, React.ReactNode> = {
    dashboard: <DashboardKPI />,
    users: <UsersTab />,
    vets: <VetsTab />,
    visit_types: <VisitTypesTab />,
    specialties: <SpecialtiesTab />,
    owners: <OwnersTab />,
    patients: <PatientsTab />,
    appointments: <AppointmentsTab />,
    config: <ConfigTab />,
    push: <PushTab />,
    system: <SystemStatusTab />,
  };
  return (
    <AppLayout breadcrumbs={[{ label: "Impostazioni" }]} mainClassName="p-0">
      <div className="settings-layout">
        <nav className="settings-nav" aria-label="Impostazioni">
          <h2>Ospedale veterinario</h2>
          {tabs.map((tab) => (
            <button
              type="button"
              key={tab.id}
              aria-current={activeTab === tab.id ? "page" : undefined}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.icon}
              {tab.label}
            </button>
          ))}
        </nav>
        <section className="settings-content">
          <select
            className="settings-mobile-select"
            aria-label="Sezione impostazioni"
            value={activeTab}
            onChange={(e) => setActiveTab(e.target.value)}
          >
            {tabs.map((tab) => (
              <option value={tab.id} key={tab.id}>
                {tab.label}
              </option>
            ))}
          </select>
          <header>
            <h2>{tabs.find((tab) => tab.id === activeTab)!.label}</h2>
          </header>
          <div key={activeTab}>{panels[activeTab]}</div>
        </section>
      </div>
    </AppLayout>
  );
}
